import React from "react";
import { Mutation, Query } from "react-apollo";
import TextArea from "../../components/TextArea";
import PowerBIComponent from "../../components/PowerBI";
import ImageUpload from "../../components/ImageUpload";
import NewsletterModal from "../../components/NewsletterModal";
import RelatedPosts from "../../components/RelatedPosts";
import NewsletterSignup from "../../components/NewsletterSignup";
import CategorySelect from "../../components/CategorySelect";
import VendorSelect from "../../components/VendorSelect";
import HtmlEditor from "../../components/HtmlEditor";
import LoginModal from "../../components/LoginModal"; // NOT a draggable component
import { DragDropContext, Droppable } from "react-beautiful-dnd";
import DraggableComponent from "./DraggableComponent";
import FreeTrialModal from "../../components/FreeTrialModal";
import FreeReportRequest from "../../components/FreeReportRequest";
import uuid from "uuid/v4";
import moment from "moment";
import gql from "graphql-tag";
import {
  reorder,
  updateItem,
  deleteItem,
  updateAllItems,
  escapeString,
  unescapeString,
} from "./helpers";
import { DEFAULT_IMAGE } from "../../constants";

const componentForType = (type) => {
  switch (type) {
    case "text-content":
      return TextArea;
    case "powerbi-component":
      return PowerBIComponent;
    case "image-upload-component":
      return ImageUpload;
    case "newsletter-modal-component":
      return NewsletterModal;
    case "related-posts":
      return RelatedPosts;
    case "newsletter-signup":
      return NewsletterSignup;
    case "html-embed":
      return HtmlEditor;
    case "free-trial-modal":
      return FreeTrialModal;
    // TODO: handle other components (image upload, etc)
    case "free-report-request":
      return FreeReportRequest;
    default:
      return type;
  }
};

class CreateEditPost extends React.Component {
  constructor(props) {
    super(props);

    this.initialState = {
      id: null,
      components: [],
      publishDate: "",
      slug: `/${props.match.params.type}/`.toLowerCase(),
      seo: {
        keywords: [],
        description: "",
      },
      search: "",
      title: "",
      subtitle: "",
      categories: [],
      vendorsMentioned: [],
      createdBy: "",
      lastUpdatedAt: null,
      active: false,
      html: "",
      hideHeaderImage: false,
      loginModalOpen: false,
      isPublic: false,
    };

    if (props.post) {
      this.initialState.id = props.post.id;
      this.initialState.components = (props.post.components || []).map(
        (item) => ({
          id: uuid(),
          type: item.type,
          props: item.props || {},
        })
      );

      // If newsletter, get html
      if (!props.withComponents && props.postType === "NEWS") {
        let scriptComponent = props.post.components.find(
          ({ type }) => type === "script"
        );

        let scriptContent = scriptComponent
          ? scriptComponent.props.dangerouslySetInnerHTML.__html
          : null;

        if (scriptContent) {
          const scriptRegex = /doc\.write\(\"([^\n]+)\"\);/g;

          let match = scriptRegex.exec(scriptContent);
          if (match !== null && match[1]) {
            let escapedHtml = match[1];
            this.initialState.html = unescapeString(escapedHtml);
          }
        }
      }

      if (props.post.seo) {
        this.initialState.seo.keywords = props.post.seo.keywords || [];
        this.initialState.seo.description = props.post.seo.description || "";
      }

      if (props.post.slug && props.post.slug[0]) {
        this.initialState.slug = props.post.slug[0];
      }
      if (props.post.publishDate) {
        this.initialState.publishDate = new Date(
          props.post.publishDate
        ).toISOString();
      }

      if (props.post.lastUpdatedAt) {
        this.initialState.lastUpdatedAt = new Date(
          props.post.lastUpdatedAt
        ).toISOString();
      }

      let vendorsMentionedStripTypename;

      if (props.post.vendorsMentioned) {
        vendorsMentionedStripTypename = props.post.vendorsMentioned.map(
          (el) => {
            return { id: el.id, name: el.name, slug: el.slug };
          }
        );
      }

      this.initialState.title = props.post.title || "";
      this.initialState.subtitle = props.post.subtitle || "";
      this.initialState.categories = props.post.categories || [];
      this.initialState.vendorsMentioned = vendorsMentionedStripTypename || [];
      this.initialState.createdBy = props.post.createdBy || "";
      this.initialState.active = props.post.active || false;
      this.initialState.hideHeaderImage = props.post.hideHeaderImage || false;
      this.initialState.isPublic = props.post.isPublic || false;
    }

    this.state = {
      ...this.initialState,
    };

    this.autoSaveInterval;
    this.postLockoutInterval;
  }

  componentDidMount = () => {
    if (this.props.post && !this.props.post.canAccessPost.value) {
      this.props.history.push(`/articles/`);
    }

    // Auto save every 30 seconds
    this.autoSaveInterval = setInterval(() => this.saveChanges(true), 30000);

    // Update post lockout timer every 15 seconds
    this.postLockoutInterval = setInterval(() => this.postLockout(), 15000);
  };

  componentDidUpdate = (prevProps) => {
    const { type } = this.props.match.params;

    if (type !== prevProps.match.params.type && type !== null) {
      this.setState({
        slug: `/${type}/`,
      });
    }
  };

  postLockout = async () => {
    let post_id = this.props.post ? this.props.post.id : this.state.id;

    if (post_id && !this.state.loginModalOpen) {
      try {
        const { data } = await this.props.postLockout(post_id);
        if (!data.postLockout.success) {
          throw Error("Post Lockout has failed!");
        }
      } catch (err) {
        if (
          err.graphQLErrors &&
          err.graphQLErrors[0] &&
          err.graphQLErrors[0].message === "User is not authenticated"
        ) {
          this.setState({ loginModalOpen: true });
        }
      }
    }
  };

  handleVendorInputChange = (input) => {
    this.setState({ search: input });
  };

  handleVendorChange = (selected) => {
    this.setState({
      vendorsMentioned: (selected || []).map((elem) => ({
        id: elem.id,
        name: elem.value,
        slug: elem.slug,
      })),
    });
  };

  componentWillUnmount = () => {
    clearInterval(this.autoSaveInterval);
    clearInterval(this.postLockoutInterval);
  };

  resetState = () => {
    this.setState(this.initialState);
  };

  removeComponentErrors = () => {
    let components = updateAllItems(this.state.components, { error: false });

    this.setState({ components });
  };

  validateInput = (showError) => {
    this.removeComponentErrors();

    const { type } = this.props.match.params;
    const slugRegex = new RegExp(`^\\/${type}\\/[\\w\\-\\d]*$`, "i");
    if (
      this.state.active &&
      (!this.state.slug || this.state.slug === `/${type}/`.toLowerCase())
    ) {
      return "Route is required";
    }

    if (!slugRegex.test(this.state.slug)) {
      return "Invalid route.";
    }

    if (
      this.state.html === "" &&
      this.props.postType === "NEWS" &&
      this.state.active
    ) {
      return "Must add HTML to make newsletter active";
    }

    if (this.props.postType !== "NEWS") {
      if (!this.state.title) {
        return "Title is required";
      }

      if (this.state.active) {
        let headerImageDesktop = this.getHeaderImageData("desktop");
        let headerImageMobile = this.getHeaderImageData("mobile");
        if (!headerImageDesktop.uri || !headerImageDesktop.fileName) {
          return "Header Image (Desktop) is required";
        }

        if (!headerImageMobile.uri || !headerImageMobile.fileName) {
          return "Header Image (Mobile) is required";
        }
      }
    }

    if (this.props.withComponents) {
      let componentCounts = {};

      for (let i = 0; i < this.state.components.length; i++) {
        let component = this.state.components[i];

        let isValid = this[component.id].validate();

        if (!isValid) {
          if (showError) {
            let componentsWithErrors = updateItem(
              this.state.components,
              component.id,
              { error: true }
            );

            this.setState({ components: componentsWithErrors }, () =>
              setTimeout(() => this.removeComponentErrors(), 5000)
            );
          }
          return `Error in component ${i + 1}. Highlighted in red below.`;
        } else {
          if (componentCounts[component.type]) {
            componentCounts[component.type] += 1;
          } else {
            componentCounts[component.type] = 1;
          }
        }
      }

      if (this.state.active) {
        const noDupComponents = [
          { key: "related-posts", name: "Related Pages" },
          { key: "newsletter-modal-component", name: "Newsletter Modal" },
          { key: "newsletter-signup", name: "Newsletter Signup" },
          { key: "free-trial-modal", name: "Free Trial Modal" },
          { key: "free-report-request", name: "Free Report Request" },
        ];
        for (const { key, name } of noDupComponents) {
          if (componentCounts[key] && componentCounts[key] > 1) {
            return `You may not include more than one ${name} component.`;
          }
        }
      }
    }

    return true;
  };

  getHeaderImageData = (type) => {
    if (type === "desktop") {
      let headerImageDesktop = this.headerImage.getValue();
      return headerImageDesktop.props;
    } else if (type === "mobile") {
      let headerImageMobile = this.headerImageMobile.getValue();
      return headerImageMobile.props;
    } else {
      throw new Error("getHeaderImageData argument must be mobile or desktop");
    }
  };

  getCategoriesData = () => {
    let selectedCategories = this.categories.getValue();
    return selectedCategories.props;
  };

  saveChanges = async (isAutoSave) => {
    // Only articles may be autosaved
    if (isAutoSave && this.props.postType !== "ARTICLE") {
      return;
    }

    // If the login modal is open, do not save
    if (this.state.loginModalOpen) {
      return;
    }

    try {
      // If autosave, don't save or redirect (but update initialState to whatever was updated/created)
      let isValid = this.validateInput(!isAutoSave);
      if (isValid !== true) {
        if (!isAutoSave) {
          alert(isValid);
        }
        return;
      }

      let seoImage, headerImage;
      if (this.props.postType === "NEWS") {
        seoImage = DEFAULT_IMAGE;
        headerImage = null;
      } else {
        headerImage = {
          desktop: this.getHeaderImageData("desktop"),
          mobile: this.getHeaderImageData("mobile"),
        };
        seoImage = headerImage.mobile.uri || DEFAULT_IMAGE;

        if (!headerImage.desktop.uri && !headerImage.mobile.uri) {
          headerImage = null;
        }
      }

      let selectedCategories = this.getCategoriesData();
      let catArray = [];
      selectedCategories.selectedOptions.forEach((elem) => {
        catArray.push(elem.value);
      });

      let variables = {
        ...this.state,
        categories: catArray,
        createdBy: this.state.createdBy,
        seo: {
          "@context": "http://schema.org",
          "@type": "Article",
          url: "https://etr.plus" + this.state.slug,
          dateCreated: this.state.seo.dateCreated || new Date().toISOString(),
          image: seoImage,
          datePublished: this.state.publishDate,
          dateModified: new Date().toISOString(),
          publisher: "Aptiviti",
          description: this.state.seo.description,
          keywords: this.state.seo.keywords,
        },
        headerImage,
      };

      if (isAutoSave || variables.slug === "/articles/") {
        delete variables.slug;
      }

      let componentValues = [];

      if (this.state.components) {
        for (const component of this.state.components) {
          if (this.props.withComponents) {
            let value = this[component.id].getValue();
            componentValues.push(value);
          } else {
            componentValues.push({
              type: component.type,
              props: component.props,
            });
          }
        }
      }

      const { data } = await this.props.savePost({
        variables: {
          ...variables,
          components: componentValues,
        },
      });

      if (!isAutoSave) {
        alert(`${this.props.typeName} successfully saved!`);
      }

      let newState = {
        ...variables,
        slug: this.state.slug,
        id: data.createOrEditPost.id,
        lastUpdatedAt: moment(
          data.createOrEditPost.lastUpdatedAt,
          "x"
        ).toISOString(),
      };

      this.initialState = newState;
      this.setState(newState);
    } catch (err) {
      console.log("Error saving article: ", err);
      if (
        err.graphQLErrors &&
        err.graphQLErrors[0] &&
        err.graphQLErrors[0].message === "Not Authenticated"
      ) {
        // If we're getting a "Not Authenticated" error on save, open the modal
        // and prompt the user to log in again
        this.setState({ loginModalOpen: true });
      } else if (!isAutoSave) {
        if (err.graphQLErrors && err.graphQLErrors[0]) {
          alert(err.graphQLErrors[0].message);
        } else {
          alert(`Error saving ${this.props.typeName.toLowerCase()}.`);
        }
      }
    }
  };

  onChangeInput = (e) => {
    e.persist();

    const seoRegex = /^SEO_[\w]+$/;

    let isSeo = seoRegex.test(e.target.name);
    let name = e.target.name.replace("SEO_", "");

    let value;
    switch (name) {
      case "publishDate":
        value = e.target.value ? new Date(e.target.value).toISOString() : "";
        break;
      case "categories":
      case "keywords":
        value = e.target.value.split(",");
        break;
      case "slug": {
        const { type } = this.props.match.params;
        const slugRegex = new RegExp(`^\\/${type}\\/[\\w\\- \\d]*$`, "i");
        if (slugRegex.test(e.target.value)) {
          value = e.target.value.toLowerCase().replace(/ /g, "-");
        } else {
          value = this.state.slug.toLowerCase();
        }
        break;
      }
      case "active":
      case "hideHeaderImage":
      case "isPublic":
        value = e.target.checked;
        break;
      default:
        value = e.target.value;
        break;
    }
    if (isSeo) {
      this.setState(({ seo }) => ({
        seo: { ...seo, [name]: value },
      }));
    } else {
      this.setState({
        [name]: value,
      });
    }
  };

  onChangeHtmlContent = (e) => {
    e.persist();

    let html = e.target.value;
    let script = `
      var doc = document.getElementById('newsletter-iframe').contentWindow.document;
      doc.open();
      doc.write("${escapeString(html)}");
      links = doc.querySelectorAll("a");
      for(i = 0; i < links.length; i++) {
        links[i].setAttribute("target", "_parent");
      }
      doc.close();
    `;

    let components = [
      {
        id: uuid(),
        type: "iframe",
        props: {
          id: "newsletter-iframe",
          className: "html-content",
        },
      },
      {
        id: uuid(),
        type: "script",
        props: {
          dangerouslySetInnerHTML: {
            __html: script,
          },
        },
      },
    ];

    this.setState({ html, components });
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    let components = reorder(
      this.state.components,
      result.source.index,
      result.destination.index
    );

    this.setState({ components });
  };

  changeComponentType = (component, type) => {
    let updates = {
      type,
      props: {},
    };

    let components = updateItem(this.state.components, component.id, updates);

    this.setState({ components });
  };

  addComponent = () => {
    this.setState(({ components }) => ({
      components: [
        ...components,
        {
          id: uuid(),
          type: "text-content",
          props: {},
        },
      ],
    }));
  };

  deleteComponent = (component) => {
    let components = deleteItem(this.state.components, component.id);
    this.setState({ components });
  };

  _renderDraggable = (item, i) => {
    let { type, props, error, id } = item;
    const ComponentType = componentForType(type);
    return (
      <DraggableComponent
        key={id}
        id={id}
        index={i}
        type={type}
        error={error}
        onChangeType={(newType) => this.changeComponentType(item, newType)}
        onDelete={() => this.deleteComponent(item)}
      >
        <ComponentType
          {...props}
          id={id}
          ref={(element) => (this[item.id] = element)}
        />
      </DraggableComponent>
    );
  };

  _renderInputFields = (title, inputFields) => {
    return (
      <div className="input-container">
        <h3>{title}</h3>
        {inputFields.map((item, i) => {
          let { label, hidden, ...inputProps } = item;
          if (hidden) return null;

          let value = this.state[inputProps.name];
          if ("value" in inputProps) {
            value = inputProps.value;
          }

          let input;
          if (inputProps.type === "textarea") {
            delete inputProps.type;
            input = (
              <TextArea
                html={value}
                ref={(element) => (this[inputProps.name] = element)}
                placeholder={label}
                onChange={this.onChangeInput}
                handleReturn={() => "handled"}
                className="single-line"
                toolbarConfig={{
                  options: ["inline", "link", "history"],
                  inline: {
                    options: ["italic", "underline", "strikethrough"],
                    italic: { className: "toolbar-button" },
                    underline: { className: "toolbar-button" },
                    strikethrough: { className: "toolbar-button" },
                  },
                  link: {
                    link: { className: "toolbar-button" },
                    unlink: { className: "toolbar-button" },
                  },
                  history: {
                    undo: { className: "toolbar-button" },
                    redo: { className: "toolbar-button" },
                  },
                }}
                {...inputProps}
              />
            );
          } else if (inputProps.type === "imageupload") {
            input = (
              <ImageUpload
                ref={(element) => (this[inputProps.name] = element)}
                placeholder="Image Name"
                imageLink={false}
                onChange={this.onChangeInput}
                {...inputProps}
              />
            );
          } else if (inputProps.type === "categorySelect") {
            input = (
              <CategorySelect
                ref={(element) => (this[inputProps.name] = element)}
                selectedOptions={this.state.categories.map((val) => {
                  return { value: val, label: val };
                })}
                {...inputProps}
              />
            );
          } else if (inputProps.type === "vendorSelect") {
            input = (
              <VendorSelect
                handleInputChange={this.handleVendorInputChange}
                handleChange={this.handleVendorChange}
                search={this.state.search}
                vendorsMentioned={this.state.vendorsMentioned}
              />
            );
          } else {
            input = (
              <input
                value={value}
                ref={(element) => (this[inputProps.name] = element)}
                placeholder={label}
                onChange={this.onChangeInput}
                data-cy={`${inputProps.name}`}
                {...inputProps}
              />
            );
          }

          return (
            <div key={i} className={`input-item input-${inputProps.type}`}>
              <label>
                {label} {inputProps.required ? "*" : ""}
              </label>
              {input}
              {inputProps.maxLength && (
                <span className="input-description">
                  Characters remaining: {300 - (value || "").length}
                </span>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  _renderPostBody = () => {
    if (this.props.withComponents) {
      return (
        <div className="input-container">
          <h3>Components</h3>
          <DragDropContext onDragEnd={this.onDragEnd}>
            <Droppable droppableId="droppable">
              {(provided, snapshot) => (
                <div
                  ref={provided.innerRef}
                  className={`droppable ${
                    snapshot.isDraggingOver ? "dragging-over" : ""
                  }`}
                >
                  {this.state.components.map(this._renderDraggable)}
                  {provided.placeholder}
                  <div id="add-component" onClick={this.addComponent}>
                    <span className="glyphicon glyphicon-plus" />
                    ADD COMPONENT
                  </div>
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      );
    } else if (this.props.postType === "NEWS") {
      return (
        <div className="input-container">
          <h3>HTML Content</h3>
          <div className="input-item input-textarea">
            <textarea
              id="html-content"
              name="html"
              value={this.state.html}
              onChange={this.onChangeHtmlContent}
              placeholder="Input the raw HTML for this newsletter"
            />
          </div>
        </div>
      );
    }

    return null;
  };

  populateHeaderImage = () => {
    let headerImageResult = {
      desktop: {
        uri: "",
        description: "",
        fileName: "",
      },
      mobile: {
        uri: "",
        description: "",
        fileName: "",
      },
    };

    if (!this.props || !this.props.post || !this.props.post.headerImage) {
      return headerImageResult;
    }

    let headerImage = this.props.post.headerImage;

    if (headerImage.desktop) {
      headerImageResult.desktop.uri = headerImage.desktop.uri;
      headerImageResult.desktop.fileName = headerImage.desktop.fileName;
      headerImageResult.desktop.description = headerImage.desktop.description;
    }

    if (headerImage.mobile) {
      headerImageResult.mobile.uri = headerImage.mobile.uri;
      headerImageResult.mobile.fileName = headerImage.mobile.fileName;
      headerImageResult.mobile.description = headerImage.mobile.description;
    }

    return headerImageResult;
  };

  previewArticle = () => {
    if (this.props.post && this.props.post.id) {
      let id = this.props.post.id;
      let postType = this.props.postType;

      let type = null;

      if (postType === "ARTICLE") {
        type = "articles";
      } else if (postType === "NEWS") {
        type = "newsletters";
      } else {
        alert("An error occured while trying to preview the post.");
        return;
      }

      window.open(`/${type}/${id}/preview`).focus();
    } else {
      alert("Post not found!");
    }
  };

  _renderLoginModal = () => {
    if (!this.state.loginModalOpen) return null;
    return (
      <LoginModal close={() => this.setState({ loginModalOpen: false })} />
    );
  };

  render = () => {
    let { title, postType } = this.props;

    let headerImage = this.populateHeaderImage();

    const metaInputFields = [
      {
        label: "Title",
        name: "title",
        type: "textarea",
        required: postType !== "NEWS",
        hidden: postType === "NEWS",
      },
      {
        label: "Subtitle",
        name: "subtitle",
        hidden: postType === "NEWS",
      },
      {
        label: "Route",
        name: "slug",
        required: this.state.active,
      },
      {
        label: "Active",
        name: "active",
        type: "checkbox",
        checked: this.state.active,
      },
      {
        label: "Publish Date *",
        type: "datetime-local",
        name: "publishDate",
        value: this.state.publishDate
          ? moment(this.state.publishDate).format("YYYY-MM-DD[T]HH:mm:ss")
          : "",
        hidden: !this.state.active,
      },
      {
        label: "Public",
        name: "isPublic",
        type: "checkbox",
        checked: this.state.isPublic,
      },
      {
        label: "Author(s)",
        name: "createdBy",
        type: "textarea",
        placeholder: "Input a comma-separated list of authors",
      },
      {
        label: "Hide Header Image",
        name: "hideHeaderImage",
        type: "checkbox",
        checked: this.state.hideHeaderImage,
        hidden: postType === "NEWS",
      },
      {
        label: "Header image (Desktop - 1400x400)",
        type: "imageupload",
        name: "headerImage",
        id: "headerImageDesktop",
        accept: "image/*,.jpg,.png",
        uri: headerImage.desktop.uri,
        fileName: headerImage.desktop.fileName,
        description: headerImage.desktop.description,
        required: this.state.active,
        dimensions: {
          x: 1400,
          y: 400,
        },
        hidden: postType === "NEWS",
      },
      {
        label: "Header image (Mobile - 800x400)",
        type: "imageupload",
        name: "headerImageMobile",
        id: "headerImageMobile",
        accept: "image/*,.jpg,.png",
        uri: headerImage.mobile.uri,
        fileName: headerImage.mobile.fileName,
        description: headerImage.desktop.description,
        required: this.state.active,
        dimensions: {
          x: 800,
          y: 400,
        },
        hidden: postType === "NEWS",
      },
      {
        label: "Categories",
        name: "categories",
        type: "categorySelect",
        placeholder: "Input categories.",
      },
      {
        label: "Vendors",
        name: "vendors",
        type: "vendorSelect",
        placeholder: "Select vendors",
      },
    ];

    const seoInputFields = [
      {
        label: "Keyword(s)",
        name: "SEO_keywords",
        value: this.state.seo.keywords.join(","),
      },
      {
        label: "Description",
        name: "SEO_description",
        type: "textarea",
        value: this.state.seo.description,
        maxLength: 300,
      },
    ];

    return (
      <div className="create-edit-post-container">
        <div className="create-edit-post-header">
          <h2>{title}</h2>
          <div className="button-container">
            {this.state.lastUpdatedAt && (
              <div className="last-saved">
                Last saved at:{" "}
                {moment(this.state.lastUpdatedAt).format("YYYY-MM-DD HH:mm:ss")}
              </div>
            )}
            <div
              className="button-item submit"
              onClick={() => this.saveChanges(false)}
              data-cy="save-post"
            >
              Save {this.props.typeName}
            </div>
            {this.state.id && (
              <div
                className="button-item preview"
                onClick={this.previewArticle}
              >
                Preview
              </div>
            )}
          </div>
        </div>
        {this._renderInputFields("Meta", metaInputFields)}
        {this._renderInputFields("SEO", seoInputFields)}
        {this._renderPostBody()}
        {this._renderLoginModal()}
      </div>
    );
  };
}

const GetPostQuery = gql`
  query GET_POST($id: String!, $postType: PostType) {
    post(id: $id, postType: $postType) {
      id
      slug
      postType
      title
      subtitle
      file
      categories
      components {
        type
        props
      }
      createdBy
      publishDate
      lastUpdatedAt
      seo
      active
      canAccessPost(update: true)
      headerImage {
        desktop {
          uri
          fileName
          description
        }
        mobile {
          uri
          fileName
          description
        }
      }
      hideHeaderImage
      vendorsMentioned {
        id
        name
        slug
      }
      isPublic
    }
  }
`;

const CreateEditPostMutation = gql`
  mutation CREATE_OR_EDIT_POST(
    $id: String
    $postType: PostType!
    $title: String!
    $slug: String
    $subtitle: String
    $headerImage: headerImageInput
    $categories: [String]
    $components: [PostComponentInput]
    $createdBy: String
    $publishDate: String
    $seo: json
    $active: Boolean!
    $hideHeaderImage: Boolean!
    $vendorsMentioned: [VendorInput]
    $isPublic: Boolean
  ) {
    createOrEditPost(
      id: $id
      postType: $postType
      title: $title
      slug: $slug
      subtitle: $subtitle
      categories: $categories
      components: $components
      createdBy: $createdBy
      publishDate: $publishDate
      seo: $seo
      active: $active
      headerImage: $headerImage
      hideHeaderImage: $hideHeaderImage
      vendorsMentioned: $vendorsMentioned
      isPublic: $isPublic
    ) {
      id
      slug
      postType
      title
      subtitle
      file
      categories
      components {
        type
        props
      }
      createdBy
      publishDate
      lastUpdatedAt
      seo
      active
      headerImage {
        desktop {
          uri
          description
          fileName
        }
        mobile {
          uri
          description
          fileName
        }
      }
      hideHeaderImage
      vendorsMentioned {
        id
        name
        slug
      }
      isPublic
    }
  }
`;

const LockoutPostMutation = gql`
  mutation LOCKOUT_UPDATE($post_id: String!) {
    postLockout(post_id: $post_id)
  }
`;

const CreateEditPostWithLockoutMutation = (props) => {
  return (
    <Mutation mutation={LockoutPostMutation}>
      {(mutate) => {
        const postLockout = (post_id) => {
          return mutate({
            variables: { post_id: post_id },
          });
        };

        return <CreateEditPost {...props} postLockout={postLockout} />;
      }}
    </Mutation>
  );
};

const CreateEditPostWithMutation = (props) => {
  return (
    <Mutation mutation={CreateEditPostMutation}>
      {(mutate) => {
        const savePost = (config) => {
          return mutate({
            ...config,
            variables: { ...config.variables, postType: props.postType },
          });
        };

        return (
          <CreateEditPostWithLockoutMutation {...props} savePost={savePost} />
        );
      }}
    </Mutation>
  );
};

const CreateEditPostWithData = (props) => {
  let postType, withComponents, typeName;

  switch (props.match.params.type.toLowerCase()) {
    case "articles":
      withComponents = true;
      postType = "ARTICLE";
      typeName = "Article";
      break;
    case "newsletters":
      withComponents = false;
      postType = "NEWS";
      typeName = "Newsletter";
      break;
    default:
      return "Error! Invalid post type.";
  }
  if (!props.match.params.id) {
    return (
      <CreateEditPostWithMutation
        {...props}
        postType={postType}
        withComponents={withComponents}
        title={`Create New ${typeName}`}
        typeName={typeName}
      />
    );
  }

  let { id } = props.match.params;
  return (
    <Query
      query={GetPostQuery}
      variables={{ id, postType }}
      fetchPolicy="network-only"
    >
      {({ loading, error, data }) => {
        if (loading) return "Loading...";
        if (error) return `Error! ${error.message}`;
        if (!data.post) {
          return `Error! ${typeName} not found.`;
        }
        return (
          <CreateEditPostWithMutation
            {...props}
            post={data.post}
            postType={postType}
            withComponents={withComponents && !data.post.file}
            title={`Edit ${typeName}`}
            typeName={typeName}
          />
        );
      }}
    </Query>
  );
};

export default CreateEditPostWithData;
